import type { PlainPrebuild } from "@/queries/prebuild-queries";
import { prebuildAdapter } from "./log-streaming/adapters";
import { useStreamLogsBase } from "./log-streaming/use-stream-logs-base";
import type { UseStreamLogsResult } from "./log-streaming/types";

/**
 * Hook for streaming prebuild logs.
 * Wrapper around the generic base hook with prebuild-specific adapter.
 */
export function useStreamPrebuildLogs(options: {
    prebuild?: PlainPrebuild;
    maxLinesPerGroup?: number;
}): UseStreamLogsResult {
    return useStreamLogsBase({
        resource: options.prebuild,
        adapter: prebuildAdapter,
        maxLinesPerGroup: options.maxLinesPerGroup,
    });
}
